module.exports = __webpack_public_path__ + "static/media/locationIcon.b314b76b.svg";